module.exports = __webpack_public_path__ + "2bddfc02d7917925de9fdc3297b0b1e0.svg";